module.exports = {"attributes":{"width":"17","height":"8","viewBox":"0 0 17 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M0.717285 8L9 0L17 8\" fill=\"white\"/> <path d=\"M0.717285 8L9 0L17 8\" stroke=\"#1F1F1F\" stroke-width=\"2\"/>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/popup-tail.svg
// module id = 1435
// module chunks = 0